import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { searchArticle } from "../actions/articleActions";
import { SocialIcon } from "react-social-icons";
import logo from "../assets/bloglogo.png";
import "react-icons/ai";
import { AiOutlineSearch } from "react-icons/ai";
const Actions = ({ setArticles }) => {
  const [searchValue, setSearchValue] = useState("");
  const history = useHistory();
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    const data = {
      articleName: searchValue,
    };
    history.push(`?q=${data.articleName}`);
    const result = await searchArticle(data);
    setArticles(result);
  };
  // useEffect(() => {
  //   (async function getSearch() {})();
  // }, [searchValue, setArticles]);

  return (
    <div className="actions-article-container">
      <div className="brand">
        <img src={logo} alt="" width="100px" />
        <h1 className="text">LOG V1</h1>
      </div>
      <form onSubmit={handleSearchSubmit}>
        <input
          type="text"
          placeholder="Search article..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <button type="submit">
          <AiOutlineSearch />
        </button>
      </form>
      <div className="trending">
        <h3>Best of the Blog</h3>
        <a href="/articles-list/articles/top5/most-commented">
          Top 5 Most Talked Posts
        </a>
        <a href="/articles-list/articles/top5/top-rated">Top 5 Rated Posts</a>
        <a href="/articles-list/articles/top5/top-contributor">
          Top 5 Blog Author
        </a>
      </div>
      <h3>Follow</h3>
      <SocialIcon url="https://www.facebook.com/Demon.rimuruTempest/" />
      <SocialIcon url="https://twitter.com/jeido66612117" />
      <SocialIcon url="https://www.linkedin.com/in/jade-darunday-94a474153/" />
    </div>
  );
};

export default Actions;
